<div class="flex-wrapper">
  <div class="sub-page-root-begin-and-pay">
    <h2 class="cta" *ngIf="this.petName" [innerHtml]="'banner-header-4' | transloco : {petName  : petName }"></h2>
    <h2 class="cta" *ngIf="!this.petName" [innerHtml]="'banner-header-fallback' | transloco"></h2>

    <h3 class="h3-closing-screen">{{ 'closing-pet-information-header' | transloco : { petName: petName } }} <a
      class="edit-link" routerLink="/pet-info" queryParamsHandling="preserve">
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M17.204 10.7959L19 8.99994C19.5453 8.45469 19.8179 8.18207 19.9636 7.88797C20.2409 7.32842 20.2409 6.67146 19.9636 6.11191C19.8179 5.81782 19.5453 5.54519 19 4.99994C18.4548 4.45469 18.1821 4.18207 17.888 4.03633C17.3285 3.75905 16.6715 3.75905 16.112 4.03633C15.8179 4.18207 15.5453 4.45469 15 4.99994L13.1814 6.8186C14.1452 8.4692 15.5314 9.84476 17.204 10.7959ZM11.7269 8.27305L4.8564 15.1436C4.43134 15.5686 4.21881 15.7812 4.07907 16.0422C3.93934 16.3033 3.88039 16.5981 3.7625 17.1875L3.1471 20.2645C3.08058 20.5971 3.04732 20.7634 3.14193 20.858C3.23654 20.9526 3.40284 20.9194 3.73545 20.8529L6.81243 20.2375C7.40189 20.1196 7.69661 20.0606 7.95771 19.9209C8.21881 19.7812 8.43134 19.5686 8.8564 19.1436L15.7458 12.2542C14.1241 11.2385 12.7524 9.87622 11.7269 8.27305Z"
              fill="currentColor"/>
      </svg>
    </a></h3>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-information-species-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p *ngIf="this.species === 'cat'" [innerHtml]="'closing-pet-information-species-value-cat' | transloco"></p>
        <p *ngIf="this.species === 'dog'" [innerHtml]="'closing-pet-information-species-value-dog' | transloco"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-information-gender-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p *ngIf="this.petGender === 'm'" [innerHtml]="'closing-pet-information-gender-value-m' | transloco"></p>
        <p *ngIf="this.petGender === 'f'" [innerHtml]="'closing-pet-information-gender-value-f' | transloco"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-information-breed-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p *ngIf="this.breed === 'pedigree'"
           [innerHtml]="'closing-pet-information-breed-value-pedigree' | transloco"></p>
        <p *ngIf="this.breed === 'cross'" [innerHtml]="'closing-pet-information-breed-value-cross' | transloco"></p>
        <p *ngIf="this.breed === 'mixed'" [innerHtml]="'closing-pet-information-breed-value-mixed' | transloco"></p>
      </div>
    </div>


    <div class="closing-key-value" *ngIf="this.species === 'cat' && this.catBreed !== undefined">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-information-cat-breed-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p [innerHtml]="'closing-pet-information-cat-breed-value' | transloco : {catBreed  : catBreed }"></p>
      </div>
    </div>

    <div class="closing-key-value" *ngIf="this.species === 'dog' && this.dogBreed !== undefined">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-information-dog-breed-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p [innerHtml]="'closing-pet-information-dog-breed-value' | transloco : {dogBreed  : dogBreed }"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-information-pet-birthdate-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p>{{ formatDateISOToEurope(petBirthdate) }}</p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-information-neutered-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p *ngIf="this.neutered" [innerHtml]="'closing-pet-information-neutered-value-yes' | transloco"></p>
        <p *ngIf="!this.neutered" [innerHtml]="'closing-pet-information-neutered-value-no' | transloco"></p>
      </div>
    </div>

    <h3 class="h3-closing-screen">{{ 'closing-pet-protection-header' | transloco : { petName: petName } }} <a
      class="edit-link" routerLink="/coverage-info" queryParamsHandling="preserve">
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M17.204 10.7959L19 8.99994C19.5453 8.45469 19.8179 8.18207 19.9636 7.88797C20.2409 7.32842 20.2409 6.67146 19.9636 6.11191C19.8179 5.81782 19.5453 5.54519 19 4.99994C18.4548 4.45469 18.1821 4.18207 17.888 4.03633C17.3285 3.75905 16.6715 3.75905 16.112 4.03633C15.8179 4.18207 15.5453 4.45469 15 4.99994L13.1814 6.8186C14.1452 8.4692 15.5314 9.84476 17.204 10.7959ZM11.7269 8.27305L4.8564 15.1436C4.43134 15.5686 4.21881 15.7812 4.07907 16.0422C3.93934 16.3033 3.88039 16.5981 3.7625 17.1875L3.1471 20.2645C3.08058 20.5971 3.04732 20.7634 3.14193 20.858C3.23654 20.9526 3.40284 20.9194 3.73545 20.8529L6.81243 20.2375C7.40189 20.1196 7.69661 20.0606 7.95771 19.9209C8.21881 19.7812 8.43134 19.5686 8.8564 19.1436L15.7458 12.2542C14.1241 11.2385 12.7524 9.87622 11.7269 8.27305Z"
              fill="currentColor"/>
      </svg>
    </a></h3>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-protection-sum-insured-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p *ngIf="this.coverageLevel === 's'"
           [innerHtml]="'closing-pet-protection-sum-insured-value-s' | transloco"></p>
        <p *ngIf="this.coverageLevel === 'm'" [innerHtml]="'pet-protection-sum-insured-value-m' | transloco"></p>
        <p *ngIf="this.coverageLevel === 'l'" [innerHtml]="'pet-protection-sum-insured-value-l' | transloco"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-protection-coverage-level-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p *ngIf="this.coverageLevel === 's'"
           [innerHtml]="'closing-pet-protection-coverage-level-value-s' | transloco"></p>
        <p *ngIf="this.coverageLevel === 'm'"
           [innerHtml]="'closing-pet-protection-coverage-level-value-m' | transloco"></p>
        <p *ngIf="this.coverageLevel === 'l'"
           [innerHtml]="'closing-pet-protection-coverage-level-value-l' | transloco"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-protection-excess-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p [innerHtml]="'closing-pet-protection-excess-value' | transloco : {excess  : excess }"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-protection-copayment-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p
          [innerHtml]="'closing-pet-protection-copayment-value' | transloco : {copayment : displayCopaymentAsCoveragePercentage(copayment)}"></p>
      </div>
    </div>

    <div class="closing-key-value" *ngIf="this.globalCoverage">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-protection-addtl-coverage-global-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p [innerHtml]="'closing-pet-protection-addtl-coverage-global-value' | transloco"></p>
      </div>
    </div>

    <div class="closing-key-value" *ngIf="this.preexistingConditions">
      <div class="closing-key">
        <p [innerHtml]="'closing-pet-protection-addtl-coverage-peexisting-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p [innerHtml]="'closing-pet-protection-addtl-coverage-peexisting-value' | transloco"></p>
      </div>
    </div>

    <h3 class="h3-closing-screen">{{ 'closing-parent-information-header' | transloco }} <a class="edit-link"
                                                                                           routerLink="/parent-info"
                                                                                           queryParamsHandling="preserve">
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M17.204 10.7959L19 8.99994C19.5453 8.45469 19.8179 8.18207 19.9636 7.88797C20.2409 7.32842 20.2409 6.67146 19.9636 6.11191C19.8179 5.81782 19.5453 5.54519 19 4.99994C18.4548 4.45469 18.1821 4.18207 17.888 4.03633C17.3285 3.75905 16.6715 3.75905 16.112 4.03633C15.8179 4.18207 15.5453 4.45469 15 4.99994L13.1814 6.8186C14.1452 8.4692 15.5314 9.84476 17.204 10.7959ZM11.7269 8.27305L4.8564 15.1436C4.43134 15.5686 4.21881 15.7812 4.07907 16.0422C3.93934 16.3033 3.88039 16.5981 3.7625 17.1875L3.1471 20.2645C3.08058 20.5971 3.04732 20.7634 3.14193 20.858C3.23654 20.9526 3.40284 20.9194 3.73545 20.8529L6.81243 20.2375C7.40189 20.1196 7.69661 20.0606 7.95771 19.9209C8.21881 19.7812 8.43134 19.5686 8.8564 19.1436L15.7458 12.2542C14.1241 11.2385 12.7524 9.87622 11.7269 8.27305Z"
              fill="currentColor"/>
      </svg>
    </a>
    </h3>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-parent-information-gender-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p *ngIf="this.parentGender === 'm'" [innerHtml]="'closing-parent-information-gender-value-m' | transloco"></p>
        <p *ngIf="this.parentGender === 'f'" [innerHtml]="'closing-parent-information-gender-value-f' | transloco"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-parent-information-firstname-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p [innerHtml]="'closing-parent-information-firstname-value' | transloco : {firstName : firstName}"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-parent-information-lastname-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p [innerHtml]="'closing-parent-information-lastname-value' | transloco : {lastName : lastName}"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-parent-information-birthdate-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p>{{ formatDateISOToEurope(parentBirthdate) }}</p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-parent-information-street-and-number-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p
          [innerHtml]="'closing-parent-information-street-and-number-value' | transloco : {streetnumbernumber : street + (number?' ' + number:'') }"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-parent-information-zip-and-city-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p
          [innerHtml]="'closing-parent-information-zip-and-city-value' | transloco : {zipcity : zip + ' ' + city }"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-parent-information-phone-number-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p class="no-phone-detection"
           [innerHtml]="'closing-parent-information-phone-number-value' | transloco : {phoneNumber  : phoneNumber }"></p>
      </div>
    </div>

    <div class="closing-key-value">
      <div class="closing-key">
        <p [innerHtml]="'closing-parent-information-email-key' | transloco"></p>
      </div>
      <div class="closing-value">
        <p [innerHtml]="'closing-parent-information-email-value' | transloco : {email  : email }"></p>
      </div>
    </div>


    <h3 [innerHtml]="'closing-begin-and-pay-header' | transloco"></h3>

    <form id="begin-and-pay-form" [formGroup]="beginAndPayForm">

      <h4>{{ 'closing-payment-frequency-header' | transloco }} <span
        (click)="showAlert(paymentFrequencyInfoTitle, paymentFrequencyInfoMessage)" class="infobutton">&#9432;</span>
      </h4>
      <div class="frequency-interval-wrapper">
        <label for="yearly">
          <input id="yearly" class="form-control" value="y" type="radio"
                 (click)="track('payment-frequency', 'selector', 'yearly')" formControlName="paymentFrequency">
          <div
            [class.sibling-selected]="isSelectedById('monthly') || isSelectedById('quarterly') || isSelectedById('biyearly')"
            [class.selected]="isSelectedById('yearly')" [class.submitted-incomplete]="submittedIncomplete"
            class="choice-div-payment-frequency">
            <div class="discount-container"><p class="bold">{{ 'closing-payment-frequency-discount' | transloco }}
              3%</p></div>
            <div class="main-price"><span
              class="price bold">CHF {{ getFrequencyPrices('y')?.price| number:'1.2-2' }}</span><span
              class="interval">/{{ 'closing-payment-frequency-yearly-value' | transloco }}</span></div>
            <div class="full-price"><p class="bold text-decoration-line-through">
              CHF {{ getFrequencyPrices('y')?.fullPrice| number:'1.2-2' }}</p></div>
          </div>
        </label>


        <label for="quarterly">
          <input id="quarterly" class="form-control" value="q" type="radio"
                 (click)="track('payment-frequency', 'selector', 'quarterly')" formControlName="paymentFrequency">
          <div
            [class.sibling-selected]="isSelectedById('monthly') || isSelectedById('biyearly') || isSelectedById('yearly')"
            [class.selected]="isSelectedById('quarterly')" [class.submitted-incomplete]="submittedIncomplete"
            class="choice-div-payment-frequency">
            <div class="discount-container"><p class="bold">{{ 'closing-payment-frequency-discount' | transloco }}
              1%</p></div>
            <div class="main-price"><span
              class="price bold">CHF {{ getFrequencyPrices('q')?.price| number:'1.2-2' }}</span><span
              class="interval">/{{ 'closing-payment-frequency-quarterly-value' | transloco }}</span></div>
            <div class="full-price"><p class="bold text-decoration-line-through">
              CHF {{ getFrequencyPrices('q')?.fullPrice| number:'1.2-2' }}</p></div>
          </div>
        </label>


        <label for="biyearly">
          <input id="biyearly" class="form-control" value="b" type="radio"
                 (click)="track('payment-frequency', 'selector', 'quarterly')" formControlName="paymentFrequency">
          <div
            [class.sibling-selected]="isSelectedById('monthly') || isSelectedById('quarterly') || isSelectedById('yearly')"
            [class.selected]="isSelectedById('biyearly')" [class.submitted-incomplete]="submittedIncomplete"
            class="choice-div-payment-frequency">
            <div class="discount-container"><p class="bold">{{ 'closing-payment-frequency-discount' | transloco }}
              2%</p></div>
            <div class="main-price"><span
              class="price bold">CHF {{ getFrequencyPrices('b')?.price| number:'1.2-2' }}</span><span
              class="interval">/{{ 'closing-payment-frequency-biyearly-value' | transloco }}</span></div>
            <div class="full-price"><p class="bold text-decoration-line-through">
              CHF {{ getFrequencyPrices('b')?.fullPrice| number:'1.2-2' }}</p></div>
          </div>
        </label>

        <label for="monthly">
          <input id="monthly" class="form-control" value="m" type="radio"
                 (click)="track('payment-frequency', 'selector', 'monthly')" formControlName="paymentFrequency">
          <div
            [class.sibling-selected]="isSelectedById('quarterly') || isSelectedById('biyearly') || isSelectedById('yearly')"
            [class.selected]="isSelectedById('monthly')" [class.submitted-incomplete]="submittedIncomplete"
            class="choice-div-payment-frequency">
            <div class="main-price"><span
              class="price bold">CHF {{ getFrequencyPrices('m')?.price | number:'1.2-2' }}</span><span
              class="interval">/{{ 'closing-payment-frequency-monthly-value' | transloco }}</span></div>
          </div>
        </label>
      </div>
      <!-- <p [innerHtml]="'closing-payment-by-invoice' | transloco" class="oneline-explanation-left"></p> -->

      <h4 [innerHtml]="'closing-start-date-options-header' | transloco : {petName  : petName }"></h4>
      <div class="choice-wrapper-short-2">
        <label for="start-tomorrow">
          <input id="start-tomorrow" class="form-control" value="true" type="radio"
                 (click)="track('start-date', 'selector', 'tomorrow')" formControlName="startTomorrow">
          <div
            [class.sibling-selected]="isSelectedById('start-another-day')"
            [class.selected]="isSelectedById('start-tomorrow')" class="choice-div-short-pet">
            <p [innerHtml]="'closing-start-date-options-tomorrow-value' | transloco" class="center-center-p bold"></p>
          </div>
        </label>
        <label for="start-another-day">
          <input id="start-another-day" class="form-control" value="false" type="radio"
                 (click)="track('start-date', 'selector', 'another-day')" formControlName="startTomorrow">
          <div
            [class.sibling-selected]="isSelectedById('start-tomorrow')"
            [class.selected]="isSelectedById('start-another-day')" class="choice-div-short-pet">
            <p [innerHtml]="'closing-start-date-options-another-day-value' | transloco"
               class="center-center-p bold"></p>
          </div>
        </label>
      </div>

      <div *ngIf="!startTomorrow()" class="text-input-wrapper-with-header" id="custom-start-date">
        <p [innerHtml]="'closing-start-date-datepicker-header' | transloco"></p>
        <input (ngModelChange)="startDate=$event" [class.submitted-incomplete]="submittedIncomplete"
               [minDate]="ngbDateTomorrow()" [maxDate]="ngbDateOneYearInTheFuture()" outsideDays="hidden"
               [weekdays]="false" id="start-date-picker" class="form-control text-input" formControlName="startDate"
               [placeholder]="'datepicker-placeholder'|transloco"
               (click)="d.toggle()" ngbDatepicker #d="ngbDatepicker" (keydown.enter)="blur($event.target)"
               (blur)="track('start-date', 'datepicker', startDate)">

        <p [innerHtml]="'pclosing-start-date-explanation' | transloco" class="oneline-explanation"></p>

      </div>

      <div class="infodiv" id="waiting-period-infodiv">
        <div class="infodiv-header">
          <h5 [innerHtml]="'closing-grace-period-info-header' | transloco"></h5>
        </div>
        <div [innerHtml]="'closing-grace-period-info-content' | transloco" class="infodiv-content"></div>
      </div>

      <br style="height: 0;"> <!--Dummy element to prevent margin collapsing-->

      <h3 [innerHtml]="'closing-application-questions-big-header' | transloco" class="h3-closing-screen"></h3>

      <div class="infodiv">
        <div class="infodiv-header">
          <p [innerHtml]="'closing-pet-application-questions-header' | transloco"></p>
        </div>
        <div class="infodiv-content">
          <ul>
            <li [innerHtml]="'closing-application-question-1' | transloco"></li>
            <li [innerHtml]="'closing-application-question-2' | transloco"></li>
            <li [innerHtml]="'closing-application-question-7' | transloco"></li>
            <li [innerHtml]="'closing-application-question-3' | transloco"></li>
            <li [innerHtml]="'closing-application-question-5' | transloco"></li>
          </ul>
        </div>
      </div>

    </form>

  </div>

  <footer class="closing-bottom">

    <div class="closing-bottom-content">
      <div class="total-amount-div-with-button" *ngIf="this.getCurrentTotal() && this.getSelectedFrequency()">
        <h4 *ngIf="this.showPremiumLoader" [innerHtml]="'closing-total-amount-text-loader' | transloco"></h4>

        <h4 *ngIf="this.isMonthlyPayment() && !this.showPremiumLoader"
            [innerHtml]="('closing-total-amount-text-monthly' | transloco : {displayPremiumMonthlygetCurrentTotalnumberfr : displayPremiumMonthly(getCurrentTotal()) | number:'1.2-2'}) + ' ' + (this.pricePercentageReduction !== undefined ? ('percentage-pricing-reduction-text' | transloco : {pricePercentageReduction : this.pricePercentageReduction}) : '')"></h4>
        <h4 *ngIf="this.isQuarterlyPayment() && !this.showPremiumLoader"
            [innerHtml]="('closing-total-amount-text-quarterly' | transloco : {displayPremiumQuarterlygetCurrentTotalnumberfr : displayPremiumQuarterly(getCurrentTotal()) | number:'1.2-2'}) + ' ' + (this.pricePercentageReduction !== undefined ? ('percentage-pricing-reduction-text' | transloco : {pricePercentageReduction : this.pricePercentageReduction}) : '')"></h4>
        <h4 *ngIf="this.isBiYearlyPayment() && !this.showPremiumLoader"
            [innerHtml]="('closing-total-amount-text-biyearly' | transloco : {displayPremiumBiYearlygetCurrentTotalnumberfr : displayPremiumBiYearly(getCurrentTotal()) | number:'1.2-2'}) + ' ' + (this.pricePercentageReduction !== undefined ? ('percentage-pricing-reduction-text' | transloco : {pricePercentageReduction : this.pricePercentageReduction}) : '')"></h4>
        <h4 *ngIf="this.isYearlyPayment() && !this.showPremiumLoader"
            [innerHtml]="('closing-total-amount-text-yearly' | transloco : {displayPremiumYearlygetCurrentTotalnumberfr : displayPremiumYearly(getCurrentTotal()) | number:'1.2-2'}) + ' ' + (this.pricePercentageReduction !== undefined ? ('percentage-pricing-reduction-text' | transloco : {pricePercentageReduction : this.pricePercentageReduction}) : '')"></h4>
        <!--
            <h4 *ngIf="!this.isQuarterlyPayment()" [innerHtml]="'closing-total-amount-text-yearly' | transloco"></h4>
        -->

        <p *ngIf="this.showRiskCarrierFooter() && !this.isBrokerFlow"
           [innerHtml]="'closing-submit-button-explanation-risk-carrier-b-2-c' | transloco : {getGICPath : getGICPath(), getPrivacyPolicyPath: getPrivacyPolicyPath(), getInformationDutyPath: getInformationDutyPath(), getPISPath: getPISPath() }"
           class="oneline-explanation"></p>

        <p *ngIf="this.showRiskCarrierFooter() && this.isBrokerFlow"
           [innerHtml]="'closing-submit-button-explanation-risk-carrier-b-2-b-2-c' | transloco : {getGICPath : getGICPath(), getPrivacyPolicyPath: getPrivacyPolicyPath(), getInformationDutyPath: getInformationDutyPath(), getPISPath: getPISPath() }"
           class="oneline-explanation"></p>

        <form *ngIf="!this.showRiskCarrierFooter()" [formGroup]="beginAndPayForm">
          <label for="term-agreement">
            <input id="term-agreement" class="form-control" value="false" type="checkbox"
                   formControlName="termsAgreement"
                   (click)="track('term-agreement', 'selector', 'term-agreement')">
            <div>
              <p *ngIf="!this.showRiskCarrierFooter()"
                 [innerHtml]="'closing-submit-button-explanation' | transloco : {getGICPath : getGICPath(), getPrivacyPolicyPath: getPrivacyPolicyPath(), getInformationDutyPath: getInformationDutyPath(), getPISPath: getPISPath() }"
                 class="oneline-explanation"></p>

              <p *ngIf="this.showRiskCarrierFooter() && !this.isBrokerFlow"
                 [innerHtml]="'closing-submit-button-explanation-risk-carrier-b-2-c' | transloco : {getGICPath : getGICPath(), getPrivacyPolicyPath: getPrivacyPolicyPath(), getInformationDutyPath: getInformationDutyPath(), getPISPath: getPISPath() }"
                 class="oneline-explanation"></p>

              <p *ngIf="this.showRiskCarrierFooter() && this.isBrokerFlow"
                 [innerHtml]="'closing-submit-button-explanation-risk-carrier-b-2-b-2-c' | transloco : {getGICPath : getGICPath(), getPrivacyPolicyPath: getPrivacyPolicyPath(), getInformationDutyPath: getInformationDutyPath(), getPISPath: getPISPath() }"
                 class="oneline-explanation"></p>
            </div>
          </label>
        </form>
      </div>

      <div class="total-amount-div-with-button"
           *ngIf="!this.getCurrentTotal() || !this.getSelectedFrequency()">
        <h4 [class.error]="submittedIncomplete">{{ 'closing-payment-frequency-footer-text' | transloco }}</h4>
      </div>


      <div class="two-buttons-wrapper-dynamic-direction">
        <div *ngIf="this.showB2COfferButton()">
          <button [innerHtml]="'closing-request-offer-button-customer' | transloco"
                  (click)="onSubmit('send-pdf-offer-customer')" form="parent-info-form"></button>
        </div>
        <div *ngIf="this.showDynamicDispatchControlOfferButton()">
          <button [innerHtml]="'closing-request-offer-button-customer' | transloco"
                  (click)="onSubmit('send-pdf-offer-dynamic-dispatch-control')" form="parent-info-form"></button>
        </div>
        <div class="send-offer-link-button-wrapper">
          <button id="purchase-button" [innerHtml]="'closing-submit-button-text' | transloco"
                  (click)="onSubmit('close')" form="parent-info-form"></button>
          <p *ngIf="this.showRiskCarrierFooter()" [innerHtml]="'pclosing-close-button-explanation' | transloco"
             class="oneline-explanation-inverted"></p>

        </div>
      </div>

    </div>
    <div *ngIf="this.isBrokerFlow && !this.showDynamicDispatchControlOfferButton()"
         class="two-send-offer-buttons-wrapper">
      <div (click)="this.toggleShowSendOfferButtons()">
        <h4 *ngIf="this.showSendOfferButtons" [innerHtml]="'closing-send-offer-title-open' | transloco"
            class="send-offer-dropdown-text"></h4>
        <h4 *ngIf="!this.showSendOfferButtons" [innerHtml]="'closing-send-offer-title-closed' | transloco"
            class="send-offer-dropdown-text"></h4>
      </div>
      <div *ngIf="this.showSendOfferButtons" class="two-buttons-wrapper-horizontal">
        <button [innerHtml]="'closing-send-offer-button-customer' | transloco"
                (click)="onSubmit('send-pdf-offer-customer')" form="parent-info-form"></button>
        <button [innerHtml]="'closing-send-offer-button-broker' | transloco" (click)="onSubmit('send-pdf-offer-broker')"
                form="parent-info-form"></button>
      </div>
    </div>

  </footer>
</div>
